import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FeaturesService } from '../services/features.service';

@Injectable({
  providedIn: 'root'
})
export class EpgGuard  {

  constructor(
    private featuresService: FeaturesService,
    private router: Router
  ) {}

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    return this.featuresService.epgFeatureObs.pipe(
      map(epgEnabled => {
        if (!epgEnabled) {
          this.router.navigate(['/']);
          return false;
        }
        return true;
      })
    );
  }
}
